import { render, staticRenderFns } from "./ModalFormCurrentPayments.vue?vue&type=template&id=3cfb9616"
import script from "./ModalFormCurrentPayments.vue?vue&type=script&lang=js"
export * from "./ModalFormCurrentPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports